import { render } from "./face-detection-view.vue?vue&type=template&id=00fde30a&scoped=true"
import script from "./face-detection-view.vue?vue&type=script&lang=js"
export * from "./face-detection-view.vue?vue&type=script&lang=js"

import "./face-detection-view.vue?vue&type=style&index=0&id=00fde30a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fde30a"]])

export default __exports__